import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from '../services/auth-service/auth.service';
import { StylingService } from '../services/style-service/styling.service';
import { UserService } from '../services/user-service/user.service';

@Component({
  selector: 'app-placid',
  templateUrl: './app-placid.component.html',
  styleUrls: ['./app-placid.component.scss'],
  standalone:false
})
export class AppPlacidComponent implements OnInit {
  title = 'webconfigurator';
  burgerMenu: boolean = false;
  toggleSub = new Subject<any>();

  privateProfile$: any;
  privateProfile: any;

  constructor(
    public styleService: StylingService,
    public auth: AuthService,
    public userService: UserService 
  ) { }

  ngOnInit(): void {
    let token = this.auth.getToken();
    this.privateProfile$ = this.userService.getPrivateProfile(token).subscribe(data => {
      this.privateProfile = data;
    });
  }

  onLogout(){
    this.auth.logout();
  }

  ngOnDestroy(){
    this.privateProfile$.unsubscribe();
  }

  toggle() {
    this.toggleSub.next(null);
  }

  onToggleBurgerMenu() {
    if (this.burgerMenu) {
      window.document.getElementById('burgerMenu')?.classList.remove('active');
      window.document.getElementById('placid-aside')?.classList.remove('active-placid-aside');
      this.burgerMenu = !this.burgerMenu;
    } else {
      window.document.getElementById('burgerMenu')?.classList.add('active');
      window.document.getElementById('placid-aside')?.classList.add('active-placid-aside');
      this.burgerMenu = !this.burgerMenu;
    }
  }
}
